﻿import { Button, Tab, TabsComponent } from '@components';
import { PageHeader } from '@components/PageHeader';
import { SiteTitle } from '@components/SiteTitle/SiteTitle';
import { useNavigate } from '@solidjs/router';
import { PlusIcon } from '@atgfr8/icons';
import { ConfigManager } from '@utils/ConfigManager';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { Component, createSignal } from 'solid-js';

export type CustomerSearchHeaderpProps = {
  title: string;
};
export const CustomerHeader: Component<CustomerSearchHeaderpProps> = (
  props: CustomerSearchHeaderpProps,
) => {
  const navigate = useNavigate();
  const tabs = ['Customers', 'Prospects', 'Dormant Accounts'];

  const [activeTab, setActiveTab] = createSignal(
    tabs.indexOf(
      props.title === 'Dormant Customers' ? 'Dormant Accounts' : props.title,
    ),
  );

  return (
    <PageHeader title={props.title}>
      <SiteTitle title={props.title} />
      <TabsComponent
        tabStyleClasses="hover:border-b-2 hover:border-b-[#016fa1] hover:bg-[#e0e0e0]"
        tabs={tabs.map((item) => {
          return <Tab>{item}</Tab>;
        })}
        activeTab={activeTab()}
        onTabClick={(index: number) => {
          if (index !== activeTab()) {
            const val = tabs[index];
            switch (val) {
              case 'Customers':
                navigate('/customer');
                break;
              case 'Prospects':
                navigate('/prospect');
                break;
              case 'Dormant Accounts':
                navigate('/Customer/Dormant-Accounts');
                break;
            }
          }
          setActiveTab(index);
        }}
      />
      <Button
        variant="contained"
        color="primary"
        label="Enter Prospect"
        startIcon={<PlusIcon size={20} />}
        onClick={() => {
          if (ConfigManager.showLayout) {
            navigate('/prospect/create');
          } else {
            window.open(`${ConfigManager.domainUrl}Prospect/Create`, '_blank');
          }
        }}
        dataTestId={formatDataTestId('Enter Prospect', 'button')}
      />
    </PageHeader>
  );
};
